import React from 'react'
import Eyebrow from './Eyebrow'

/**
 * A subject of Settings, on the page rather than in a box.
 *
 * The division of labour with `SettingsCard`: a card has an edge because
 * something inside it needs one — rows that rule against it, or a discrete
 * thing you act on. A form needs no edge. Drawing one around every group turned
 * a screen of six fields into a screen of six boxes, and the boxes were louder
 * than the fields.
 *
 * `meta` is the right-hand corner: a count or a price. Never an action.
 */
const SettingsSection = ({ eyebrow, meta, children }: {
  eyebrow: React.ReactNode,
  meta?: React.ReactNode,
  children: React.ReactNode,
}) => (
  <section className="py-6 first:pt-0 last:pb-0 border-b border-navy-700 last:border-b-0">
    <div className="flex items-center justify-between gap-3 mb-4">
      <Eyebrow>{eyebrow}</Eyebrow>
      {meta ? (
        <span className="font-courrier text-ds-115 text-navy-300 whitespace-nowrap">{meta}</span>
      ) : null}
    </div>
    {children}
  </section>
)

export default SettingsSection
